import { useI18n } from '@/locales/client'

export default function LoadingPage() {
  const t = useI18n()

  return (
    <div className="grid size-full min-h-screen place-items-center">
      <section
        className="flex flex-col items-center gap-2"
        role="status"
        aria-live="polite"
      >
        <div className="loader size-7" aria-hidden></div>
        <span>{t('loading')}</span>
      </section>
    </div>
  )
}
